module.exports = __webpack_public_path__ + "287548697126ffeb381265e6af6e4a6a.mp4";